export function isValidUrl(url?: string): boolean {
    const regex = /^(https?:\/\/)?([\w\-]+\.)+[a-z]{2,}(\/[\w\-._~:/?#[\]@!$&'()*+,;=]*)?$/i;
    return !url || url.trim() === '' || regex.test(url);
}